import { IdentificationIcon } from '@heroicons/react/outline';
import { FunctionComponent } from 'react';
import { serialize } from '../../utilities/richText';

type IntroductionProps = {
  introduction: any[];
  workedSinceYear: number;
  portfolio?: string;
};

const Introduction: FunctionComponent<IntroductionProps> = ({
  introduction,
  workedSinceYear,
  portfolio
}) => {
  if (!introduction || !workedSinceYear) return null;

  return (
    <div className="mt-12 content" id="introduction">
      <h2 className="mb-6 text-xl font-bold text-friendly-pink">
        Introduction
      </h2>
      <p className="text-2xl font-bold">
        <span className="pr-2 text-5xl">
          {Math.abs(new Date().getFullYear() - workedSinceYear)}
        </span>{' '}
        years experience
      </p>
      {Array.isArray(introduction) &&
        introduction.length > 0 &&
        serialize(introduction)}
      {portfolio && (
        <a
          href={portfolio}
          target="_blank"
          rel="noreferrer"
          className="inline-flex justify-center px-4 py-2 text-sm font-medium border rounded-md shadow-sm text-egg border-techy-green hover:text-techy-green focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-techy-green"
        >
          <IdentificationIcon
            className="w-5 h-5 mr-2 -ml-1"
            aria-hidden="true"
          />
          <span>View Portfolio</span>
        </a>
      )}
    </div>
  );
};

export default Introduction;
